<template>
  <div class="container-fluid">
    <div class="project-units">
      <div
        class="d-flex gap-3 justify-content-between mb-3 align-items-center project-header-stats flex-wrap"
      >
        <div class="col">
          <h3 class="mb-3">{{ project.name }}</h3>
        </div>
        <div class="d-flex gap-3 justify-content-between flex-wrap">
          <div class="total-logs">
            <h5 class="font-bold">الايرادات</h5>
            <br>

            <h6>{{ income.toLocaleString("en-US") }} </h6>
          </div>
          <div class="total-logs">
            <h5 class="font-bold">المصروفات</h5>
            <br>

            <h6>{{ expenses.toLocaleString("en-US") }} </h6>
          </div>
         
          <div class="total-logs">
            <h5 class="font-bold">الصافي</h5>
            <br>

            <h6>
              {{
                (
                  income +
                  expenses
                ).toLocaleString("en-US")
              }}
              
            </h6>
          </div>
          <div class="total-logs">
            <h5 class="font-bold">توزيع ارباح</h5>
            <br>

            <h6>
              {{
                (

                 project.profit
                ).toLocaleString("en-US")
              }}
              
            </h6>
          </div>
          <div class="total-logs">
            <h5 class="font-bold">باقي الارباح</h5>
            <br>

            <h6 v-if="( income +
                  expenses)>0">
              {{
                ( project.profit -
                  income +
                  expenses
                ).toLocaleString("en-US")
              }}
              
            </h6>
            <h6 v-else>0</h6>
          </div>
        </div>
      </div>

      <b-tabs v-model="tabIndex" pills>
    
        <b-tab :name="0" title="المصروفات" active>
          <div class="logs mt-3">
            <section class="d-flex gap-3 justify-content-between">
              <div style="width: 100%">
                <el-input
                  class="search-in-expenses"
                  placeholder="بحث في المصروفات"
                  v-model="searchInExpenses"
                />
              </div>
              <div class="mb-3">
                <el-button class="blue-btn" @click="openAddInvestmentLog = true;addInvestmentLog.type=0">
                  إضافة مصروف
                </el-button>
              </div>
            </section>

            <div
              class="d-flex flex-row-reverse mb-3 mt-0"
              style="margin-top: -100px"
            >
              <div class="total-logs">
                <h5 class="font-bold">الإجمالي</h5>
                <h6>{{ expenses.toLocaleString("en-US") }} </h6>
              </div>
            </div>
            <el-table class="table-mobile" :data="filteredLogs" style="width: 100%">
              <el-table-column width="200" label="التوقيت" data-label="التوقيت">
                <template slot-scope="scope">
                  <span class="label">التوقيت</span>
                  <div>
                    {{
                      $moment(scope.row.created_at)
                        .locale("ar")
                        .utc(false)
                        .format("llll")
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="description" label="الوصف" data-label="الوصف">
                <template slot-scope="scope">
                  <span class="label">الوصف</span>
                  <div>
                    {{ scope.row.notes }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="150" label="المبلغ" data-label="المبلغ">
                <template slot-scope="scope">
                  <span class="label">المبلغ</span>
                  <div>
                    <h6 class="text-danger">
                       {{ scope.row.amount.toLocaleString("en-US") }}
                    </h6>
                   
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </b-tab>
        <b-tab :name="1" title="الايرادات">
          <div class="logs mt-3">
            <section class="d-flex gap-3 justify-content-between">
              <div style="width: 100%">
                <el-input
                  class="search-in-expenses"
                  placeholder="بحث في الايرادات"
                  v-model="searchInExpenses"
                />
              </div>
              <div class="mb-3">
                <el-button class="blue-btn" @click="openAddInvestmentLog = true;addInvestmentLog.type=1">
                  إضافة ايراد جديد
                </el-button>
              </div>
            </section>

            <div
              class="d-flex flex-row-reverse mb-3 mt-0"
              style="margin-top: -100px"
            >
              <div class="total-logs">
                <h5 class="font-bold">الإجمالي</h5>
                <h6>{{ income.toLocaleString("en-US") }} </h6>
              </div>
            </div>
            <el-table class="table-mobile" :data="filteredIncome" style="width: 100%">
              <el-table-column width="200" label="التوقيت" data-label="التوقيت">
                <template slot-scope="scope">
                  <span class="label">التوقيت</span>
                  <div>
                    {{
                      $moment(scope.row.created_at)
                        .locale("ar")
                        .utc(false)
                        .format("llll")
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="notes" label="الوصف" data-label="الوصف">
                <template slot-scope="scope">
                  <span class="label">الوصف</span>
                  <div>
                    {{ scope.row.notes }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="150" label="المبلغ" data-label="المبلغ">
                <template slot-scope="scope">
                  <span class="label">المبلغ</span>
                  <div>
                   
                    <h6 class="text-success">
                      + {{ scope.row.amount.toLocaleString("en-US") }}
                    </h6>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </b-tab>
      </b-tabs>
    </div>

   


    <vs-popup
      class="popup-width-300"
      title="إضافة ايراد من المشروع  "
      :active.sync="openAddInvestmentLog"
    >
      <div class="popup-calender">
        <el-form :model="addInvestmentLog" ref="addInvestmentLog">
          <h6 class="mb-1">
            القيمة
            <span class="mr-5" v-if="addInvestmentLog.cost"
              >( {{ convertNumber(addInvestmentLog.cost) }} )</span
            >
          </h6>
          <el-form-item
            prop="cost"
            :rules="[{ required: true, message: 'قيمة التكلفة مطلوبة' }]"
          >
            <el-input type="number" v-model="addInvestmentLog.cost"></el-input>
          </el-form-item>

          <h6 class="mb-1">التعليق</h6>
          <el-form-item
            prop="notes"
          >
            <el-input
            :rules="[{ required: true, message: 'قيمة تفاصيل البيان مطلوبة' }]"
              type="text"
              v-model="addInvestmentLog.notes"
            ></el-input>
          </el-form-item>

       
          <el-form-item>
            <div>
              <el-button type="primary" @click="addInvestmentLogs()">
                إضافة
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </vs-popup>

  
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
import NoData from "@/components/NoData.vue";
export default {
  components: { NoData },
  computed: {
    filteredLogs: function () {
      return this.logs.filter((ele) => {
        return ele.notes.includes(this.searchInExpenses) && ele.amount <0;
      });
    },
    filteredIncome: function () {
      return this.logs.filter((ele) => {
        return ele.notes.includes(this.searchInExpenses) && ele.amount >0;
      });
    },

    calcLogsAmount() {
      let totalLogsAmount = 0;
      this.filteredLogs.forEach((ele) => {
        if (ele.type == 1) {
          totalLogsAmount += Number(ele.amount);
        } else if (ele.type == 0) {
          totalLogsAmount -= Number(ele.amount);
        }
      });
      return totalLogsAmount;
    },
  },
  created() {
    this.getInvestmentLogs();
  },
  data() {
    return {
      
      expenses: 0,
      income: 0,
      finalCalc: 0,
      editFormVisible: false,
      selectedExpenses: null,
      earthTotal: 0,
      searchInExpenses: "",
      tabIndex: 2,
      openAddNewExpense: false,
      openAddInvestmentLog: false,
      openUpdateUnitModel: false,
      updateUnit: {},
      project: {},
      units: [],
      addNewExpense: {},
      addInvestmentLog: {},
      allUnits: [],
      search: "",
      openAddUnitModel: false,
      addUnit: {
        clientType: "newClient",
        client_id: null,
        down_payment: 0,
      },
      logs: [],
      totalLogsAmount: 0,
      expenses: [],
      categories: [],
      updateUnitModel: false,
      currUnit: {},
      projectDetails: {},
      recievedCashFromUnits: 0,
      clients: [],
    };
  },
  methods: {
     destroy(unit) {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
                axiosApi
                  .delete("project_units/" + unit.id)
                  .then(res => {
                   
                      this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم حذف الوحده بنجاح",
              });
              setTimeout(() => {
                    location.reload();
                
              }, 1000);
                  })
                  .catch(e => {
                    
                    console.log(e);
                  }) .finally(() => loading.close());
            
        
      
    },
    convertNumber(val) {
      if (val > 0) {
        return Number(val).toLocaleString("en-US");
      } else {
        return "";
      }
    },
    getClients() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/clients`)
        .then((res) => {
          this.clients = res.data;
        })
        .finally(() => loading.close());
    },
    calcUnitPaied(unit) {
      console.log(unit);
      let calc = unit.down_payment;
      unit.unit_installment.map((ele) => {
        calc += +ele.paied;
      });
      return calc;
    },
    async getInvestmentLogs() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });

      try {
        let res = await axiosApi.get(
          `/investments/${this.$route.params.id}`
        );
        // console.log(res.data);
        this.project = res.data;
        this.logs = res.data.logs;
        this.income=0;
        this.expenses=0;
        this.logs.forEach((ele) => {
            if(ele.amount>0){
              this.income += +ele.amount;
            }else{
               this.expenses += +ele.amount;
            }
        });
      } finally {
        loading.close();
      }
    },
    getCategories() {
      axiosApi
        .get("categories")
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },

    projectExpenses() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });

      axiosApi
        .get(`/project_expenses/${this.$route.params.id}`)
        .then((res) => {
          this.expenses = res.data;

          this.earthTotal = 0;
          this.expenses.forEach((ele) => {
            this.earthTotal += +ele.cost;
          });

          this.totalEarth = this.earthTotal;
        })
        .finally(() => loading.close());
    },
    addInvestmentLogs() {
      this.$refs.addInvestmentLog.validate((valid) => {
        if (valid) {
          
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post(`/investment-logs`, {
              investment_id: this.$route.params.id,
              ...this.addInvestmentLog,
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.getInvestmentLogs();
              this.addInvestmentLog = {};
              this.openAddInvestmentLog = false;
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify({
                  title: "عفوا المبلغ المطلوب غير متوفر ",
                  message: `المتوفر الان ${err.response.data.balance}`,
                  type: "error",
                  duration: 1500,
                });
              } else {
                this.$notify({
                  title: "حدث خطأ",
                  message: "عفوا لم تتم العملية ",
                  type: "error",
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    addExpense2() {
      this.$refs.addExpense2.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          axiosApi
            .post("/expenses", {
              ...this.AddInvestmentLog,
              project_id: this.$route.params.id,
            })
            .then(() => {
              this.openAddInvestmentLog = false;
              this.getProjectWithUnits();
              this.getInvestmentLogs();
              this.AddInvestmentLog = {};
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات المصروف بنجاح",
                type: "success",
                duration: 1500,
              });
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify({
                  title: "عفوا المبلغ المطلوب غير متوفر ",
                  message: `المتوفر الان ${err.response.data.balance}`,
                  type: "error",
                  duration: 1500,
                });
              } else {
                this.$notify({
                  title: "حدث خطأ",
                  message: "عفوا لم تتم العملية ",
                  type: "error",
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },

    onSubmitUpdateUnit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });

          axiosApi
            .put(`/project_units/${this.updateUnit.id}`, {
              ...this.updateUnit,
              project_id: this.$route.params.id,
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم التعديل بنجاح",
              });
              this.getProjectWithUnits();
              this.getInvestmentLogs();
              this.openUpdateUnitModel = false;
            })
            .finally(() => loading.close());
        }
      });
    },
    onSubmit(projectName) {
      this.$refs[projectName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: false,
            spinner: "el-icon-loading",
            background: "rgba(255,255,255,.7)",
            customClass: "fullscreen-loading",
          });
          if (this.addUnit.clientType == "newClient") {
            this.addUnit.client_id = null;
          }
          axiosApi
            .post(`/project_units`, {
              ...this.addUnit,
              project_id: this.$route.params.id,
            })
            .then(() => {
              this.$vs.notify({
                title: "تم بنجاح",
                position: "top-center",
                color: "success",
                text: "تم الإضافة بنجاح",
              });
              this.addUnit = {
                clientType: "newClient",
                client_id: null,
              };
              this.openAddUnitModel = false;

              this.$router.go(0);
              // this.getProjectWithUnits();
              // this.getInvestmentLogs();
            })
            .catch((e) => {
              if (e.response.status == 400) {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: ` عفوا تاكد من بيانات الوحده ورقم الهاتف موجود لعميل اخر`,
                  duration: 1500,
                });
              }
            })
            .finally(() => loading.close());
        }
      });
    },
    searchInUnits() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: false,
      //   spinner: "el-icon-loading",
      //   background: "rgba(255,255,255,.7)",
      //   customClass: "fullscreen-loading",
      // });
      this.units = this.allUnits.filter((ele) => {
        return ele.description.includes(this.search);
      });
      // loading.close();
    },

    deleteItem(scope) {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .delete(`expenses/${scope.row.id}`)
        .then(() => {
          this.projectExpenses();

          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم مسح بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "عفوا تأكد من بيانات المطلوبة",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
      console.log("delete", scope.row);
    },
    editItem(scope) {
      this.selectedExpenses = scope.row;
      this.editFormVisible = true;
    },
    update() {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.selectedExpenses.cost = parseFloat(this.selectedExpenses.cost);
      axiosApi
        .put(`expenses/${this.selectedExpenses.id}`, this.selectedExpenses)
        .then(() => {
          this.projectExpenses();

          this.editFormVisible = false;
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم تحديث بيانات المنتج بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          if (e.response.status == 403) {
            this.$notify.error({
              title: "حدث خطأ",
              message: ` عفوا المبلغ غير متوفر . الخزينه بها فقط  ${e.response.data.balance}`,
              duration: 1500,
            });
          } else {
            this.$notify.error({
              title: "حدث خطأ",
              message: "عفوا تأكد من بيانات المطلوبة",
              duration: 1500,
            });
          }
        })
        .finally(() => loading.close());
    },

    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
    getProjectWithUnits() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get(`/projects/${this.$route.params.id}`)
        .then((res) => {
          this.project = res.data;
          // this.allUnits = this.project.units;
          this.logs = this.project.logs;
          // this.totalLogsAmount = 0;
          // this.logs.forEach((ele) => {
          //   if (ele.type == 1) {
          //     this.totalLogsAmount += Number(ele.amount);
          //   } else if (ele.type == 0) {
          //     this.totalLogsAmount -= Number(ele.amount);
          //   }
          // });

          // this.totalUnitsCosts = this.project.units.reduce((prev,curr) => {
          //   let sum = 0;
          //   sum += !isNaN(+prev.cost) ? +prev.cost : +prev;
          //   sum += !isNaN(+curr.cost) ? +curr.cost : +curr;
          //   return sum;
          // }, {cost: 0})

          this.totalUnitsCosts = 0;
          this.project.units.forEach((ele) => {
            this.totalUnitsCosts += Number(ele.cost);
          });

          this.totalExpenses = 0;
          this.project.logs.forEach((ele) => {
            if (ele.type == 1) {
              this.totalExpenses += Number(ele.amount);
            } else if (ele.type == 0) {
              this.totalExpenses -= Number(ele.amount);
            }
          });

          //     totalUnitsCosts: 0,
          // totalEarth: 0,
          // totalExpenses: 0,
          // finalCalc: 0,

          // this.units = this.project.units;
        })
        .finally(() => loading.close());
    },
  },
};
</script>

<style lang="scss">
.project-units {
  padding: 10px;
  .project-header-stats {
    border-bottom: 1px solid #ddd;
    padding-bottom: 15px;
  }
  .logs {
    .cell {
      padding: 10px;
    }
  }
  .total-logs {
    padding: 9px 43px;
    display: inline-block;
    background: #fff;
    margin-top: 14px;
    h6,
    h5 {
      text-align: center !important;
    }
  }
  .project-units-header {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;

    .add-unit-search {
      display: flex;
      gap: 10px;
    }
  }

  .unit {
    padding: 14px;
    background: #fff;
    cursor: pointer;
    border-radius: 10px;
    border: 1px solid #f7f7f7;
    margin-bottom: 15px;
    .head {
      gap: 10px;
      svg {
        padding: 5px;
        background-color: rgba(var(--vs-primary), 0.3) !important;
        border-radius: 5px;
        path {
          fill: #fff;
        }
      }
    }
    h6 {
      svg {
        path {
          fill: #ffcc33;
        }
      }
    }

    .unit-footer {
      display: flex;
      justify-content: space-between;
      .status {
        padding: 4px 10px;
        border-radius: 10px;
        font-weight: bold;
        &.danger {
          background-color: #ffd9d9;
          color: #ff2f2f;
        }
        &.success {
          background-color: #ecf7eb;
          color: #b8e0b6;
        }
      }
    }
  }
}

.search-in-expenses {
  width: 100% !important;
  .el-input__inner {
    width: 100% !important;
  }
}

@media (max-width: 500px) {
  .total-logs {
    width: 46%;
    padding: 9px 18px;
  }
}
</style>
